import { engineComponent, NumberUtils } from "neo-common";
import { Communication } from "neo-games";
import { ComponentTypes } from "../Components/ComponentTypes";
import { WinAnimatorExtended } from "./WinAnimatorExtended";
import { Symbol } from "../GameComponents/Symbol";
import { AppContext } from "../../Common/AppContext";
import { BetManager } from "../Managers/BetManager";
import { ImageTextCounterElement } from "../Components/Elements/Texts/ImageTextCounterElement";
import { PlayList } from "../Components/Sounds/PlayList";
import { WinAnimator } from "../GameComponents/WinAnimator";
import { FreespinsView } from "../GameComponents/Freespins/FreespinsView";
import { ModuleManager } from "../Managers/ModuleManager";
import { Payline } from "../GameComponents/Payline";
import { TimelineElement } from "../Components/Elements/Graphics/TimelineElement";

@engineComponent(ComponentTypes.DisplayObject)
export class WinAnimatorFreespins extends WinAnimatorExtended {
    //******************************************************************************************************************
    //  EVENTS
    //******************************************************************************************************************

    public static readonly FinishCustomWinCalculation: string = "eventFinishCustomWinCalculation";
    public static readonly FinishCustomWinAnimator: string = "eventFinishCustomWinAnimator";
    public static readonly FinishCustomQuickWinCalculation: string = "eventFinishCustomQuickWinCalculation";

    //******************************************************************************************************************
    //  CONFIG
    //******************************************************************************************************************

    //******************************************************************************************************************
    //  CONSTRUCTOR
    //******************************************************************************************************************

    constructor() {
        super();
    }

    public create(node: Element): void {
        super.create(node);
    }

    //******************************************************************************************************************
    //  SYMBOLS
    //******************************************************************************************************************

    protected finishFirstWins(): void {
        this.emit(WinAnimator.FinishWinAnimator);

        if (this.currentWins != null && this.currentWins.length > 0) {
            if (FreespinsView.isLastFreespin()) {
                this.allSymbolsGoToCase(Symbol.CaseNowin, true);
                this.allPaylinesGoToCase(Payline.CaseNowin);

                //todo What about sounds in this case?
                return;
            } else {
                if (this.currentWins.length == 1) {
                    this.winSymbolsGoToCase(0, Symbol.CaseSingleWin, true);
                    this.winPaylineGoToCase(0, Payline.CaseWin);
                    PlayList.play("SND_BaseRecapWinline");

                    if (!ModuleManager.freespinsEnabled() && !ModuleManager.freespinsActive()) {
                        PlayList.loop("SND_BaseRecapLoop");
                        PlayList.loop("SND_BaseBonusIdle");
                    }
                    return;
                } else if (this.currentWins.length > 1) {
                    //if scatter win, we get 2 wins (cash, fs) - still single win
                    if (
                        this.currentWins[0].trigger == Communication.Game.WinTrigger.Scatter &&
                        this.currentWins.length == 2
                    ) {
                        this.winSymbolsGoToCase(0, Symbol.CaseWin, true);
                        PlayList.play("SND_BaseRecapWinline");

                        if (!ModuleManager.freespinsEnabled() && !ModuleManager.freespinsActive()) {
                            PlayList.loop("SND_BaseRecapLoop");
                            PlayList.loop("SND_BaseBonusIdle");
                        }

                        return;
                    }

                    this.stopTimer();
                    this.currentCycle = 0;
                    this.cycleWins(true);
                }
            }
        }
    }

    protected createAnimations(): void {
        super.createAnimations();

        FreespinsView.CustomWinAnimation.on("finished", this.onCustomAnimationFinished.bind(this));
        FreespinsView.CustomWinAnimation.on(
            TimelineElement.AnimationComplete,
            this.onCustomAnimationComplete.bind(this),
        );
        FreespinsView.CustomWinAnimation.on("calculationFinished", this.onCustomCalculationFinished.bind(this));
    }

    protected onCustomAnimationFinished(): void {}

    protected onCustomAnimationComplete(): void {
        this.emit(WinAnimatorFreespins.FinishCustomWinAnimator);
    }

    protected onCustomCalculationFinished(): void {}

    protected startAnimation(): void {
        this.currentAnimationIndex = this.getAnimationIndex();
        this.currentAnimationFinished = false;

        const animation = this.animations[this.currentAnimationIndex];
        animation.visible = true;
        if (AppContext.gameConfiguration.UseCoins && BetManager.CoinSize != null) {
            ImageTextCounterElement.Round = true;
            animation.play(parseInt(NumberUtils.devide(this.currentWin, BetManager.CoinSize).toString()));
        } else {
            ImageTextCounterElement.Round = false;
            animation.play(this.currentWin);
        }

        this.loopMultipliersOfWinningSymbols();
    }

    public startCustomAnimation(currentAnimationIndex: number, value: number): void {
        //this.currentAnimationIndex = this.getAnimationIndex();
        //this.currentAnimationFinished = false;

        if (AppContext.gameConfiguration.UseCoins && BetManager.CoinSize != null) {
            ImageTextCounterElement.Round = true;
            FreespinsView.CustomWinAnimation.play(parseInt(NumberUtils.devide(value, BetManager.CoinSize).toString()));
        } else {
            ImageTextCounterElement.Round = false;
            FreespinsView.CustomWinAnimation.play(value);
        }
    }

    /**
     * Add effect on multipliers of winning symbols.
     */
    protected loopMultipliersOfWinningSymbols() {
        for (let i = 0; i < this.currentWins.length; i++) {
            let win = this.currentWins[i];
            if (win.trigger === Communication.Game.WinTrigger.Payline) {
                if (win.type === Communication.Game.WinType.Cash) {
                    FreespinsView["_multiplierS" + win.payoutId + "FS"].goToCase("FS_POP_IN_LOOP");
                }
            }
        }
    }

    protected onAnimationComplete(): void {
        for (let i = 0; i < this.currentWins.length; i++) {
            let win = this.currentWins[i];
            if (win.trigger === Communication.Game.WinTrigger.Payline) {
                if (win.type === Communication.Game.WinType.Cash) {
                    FreespinsView["_multiplierS" + win.payoutId + "FS"].goToCase("FS_POP");
                }
            }
        }

        super.onAnimationComplete();
    }

    public showWins(wins: Array<Communication.Game.IWin>, win: number): boolean {
        FreespinsView.s1MultiplierCount = FreespinsView.symbol1MultiplierCount;
        FreespinsView.s2MultiplierCount = FreespinsView.symbol2MultiplierCount;
        FreespinsView.s3MultiplierCount = FreespinsView.symbol3MultiplierCount;
        FreespinsView.s4MultiplierCount = FreespinsView.symbol4MultiplierCount;
        FreespinsView.s5MultiplierCount = FreespinsView.symbol5MultiplierCount;
        FreespinsView.s6MultiplierCount = FreespinsView.symbol6MultiplierCount;

        if (FreespinsView.symbol1hasWin == 1) {
            FreespinsView.s1MultiplierCount = 0;
        }
        if (FreespinsView.symbol2hasWin == 1) {
            FreespinsView.s2MultiplierCount = 0;
        }
        if (FreespinsView.symbol3hasWin == 1) {
            FreespinsView.s3MultiplierCount = 0;
        }
        if (FreespinsView.symbol4hasWin == 1) {
            FreespinsView.s4MultiplierCount = 0;
        }
        if (FreespinsView.symbol5hasWin == 1) {
            FreespinsView.s5MultiplierCount = 0;
        }
        if (FreespinsView.symbol6hasWin == 1) {
            FreespinsView.s6MultiplierCount = 0;
        }

        this.currentWins = wins;
        this.currentWin = win;
        const currentBet = BetManager.Bet;
        let totalWinScatter =
            FreespinsView.s1MultiplierCount * currentBet +
            FreespinsView.s2MultiplierCount * currentBet +
            FreespinsView.s3MultiplierCount * currentBet +
            FreespinsView.s4MultiplierCount * currentBet +
            FreespinsView.s5MultiplierCount * currentBet +
            FreespinsView.s6MultiplierCount * currentBet;
        let currentWinLastBet = this.currentWin - totalWinScatter;

        this.resetAnimations();

        if (wins != null && wins.length > 0) {
            this.currentMultiplierIndex = 0;

            if (FreespinsView.isLastFreespin()) {
                for (let i = 0; i < this.multipliers.length; i++) {
                    if (currentWinLastBet / BetManager.Bet >= this.multipliers[i]) {
                        this.currentMultiplierIndex = i;
                    }
                }
            } else {
                for (let i = 0; i < this.multipliers.length; i++) {
                    if (this.currentWin / BetManager.Bet >= this.multipliers[i]) {
                        this.currentMultiplierIndex = i;
                    }
                }
            }

            if (!this.showCustomWin()) {
                this.showFirstWins();
            }
            this.moveToTop();
            return this.currentMultiplierIndex >= 3;
        } else {
            this.allSymbolsGoToCase(Symbol.CaseNormal, false);
            this.startTimer(WinAnimator.Idle, this.getInitialIdleDelay());
            this.moveToTop();
            return false;
        }
    }

    protected finishFirstInitWins(): void {
        if (this.currentWins != null) {
            if (FreespinsView.isLastFreespin()) {
                this.allSymbolsGoToCase(Symbol.CaseNowin, true);
                this.allPaylinesGoToCase(Payline.CaseNowin);

                //todo What about sounds in this case?
                return;
            } else {
                if (this.currentWins.length == 1) {
                    this.winSymbolsGoToCase(0, Symbol.CaseSingleWin, true);
                    this.winPaylineGoToCase(0, Payline.CaseWin);
                    PlayList.play("SND_BaseRecapWinline");

                    if (!ModuleManager.freespinsEnabled() && !ModuleManager.freespinsActive()) {
                        PlayList.loop("SND_BaseRecapLoop");
                        PlayList.loop("SND_BaseBonusIdle");
                    }
                    return;
                } else if (this.currentWins.length > 1) {
                    //if scatter win, we get 2 wins (cash, fs) - still single win
                    if (
                        this.currentWins[0].trigger == Communication.Game.WinTrigger.Scatter &&
                        this.currentWins.length == 2
                    ) {
                        this.winSymbolsGoToCase(0, Symbol.CaseWin, true);
                        PlayList.play("SND_BaseRecapWinline");

                        if (!ModuleManager.freespinsEnabled() && !ModuleManager.freespinsActive()) {
                            PlayList.loop("SND_BaseRecapLoop");
                            PlayList.loop("SND_BaseBonusIdle");
                        }

                        return;
                    }

                    this.stopTimer();
                    this.currentCycle = 0;
                    this.cycleWins(true);
                }
            }
        }
    }

    protected cycleWins(isFirst: boolean = false): void {
        if (this.currentWins == null) {
            return;
        }

        if (isFirst) {
            this.cycleStep = 0;
        }

        for (let i = 0; i < this.currentWins.length; i++) {
            this.winSymbolsGoToCase(i, Symbol.CaseNormal, false);

            const win = this.currentWins[i];
            if (FreespinsView["_multiplierS" + win.payoutId + "FS"] != null) {
                FreespinsView["_multiplierS" + win.payoutId + "FS"].goToCase("FS");
            }
        }

        const win = this.currentWins[this.currentCycle];
        if (FreespinsView["_multiplierS" + win.payoutId + "FS"] != null) {
            FreespinsView["_multiplierS" + win.payoutId + "FS"].goToCase("FS_POP");
        }

        super.cycleWins(isFirst);
    }

    reset(showLastSymbols: boolean): boolean {
        if (this.currentWins != null) {
            for (let i = 0; i < this.currentWins.length; i++) {
                const win = this.currentWins[i];
                if (FreespinsView["_multiplierS" + win.payoutId + "FS"] != null) {
                    //FreespinsView['_multiplierS' + win.payoutId + 'FS'].goToCase(('FS_FRAME'));
                    FreespinsView["_multiplierS" + win.payoutId + "FS"].goToCase("FS");
                }
            }
        }

        return super.reset(showLastSymbols);
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/WinAnimatorFreespins.ts
 **/